import * as React from "react";
import Routes from '../../components/Routes';
import routesStatistics from '../../routes/statistics'

export default () => {
  return <Routes routes={routesStatistics} />
}